// @ts-nocheck
import React from "react";
import {Redirect, Route} from "react-router-dom";
import KeyCloak from "./Keycloak";
import {useAuth} from "./State/AuthContext";


export function PrivateRoute({ roles, children, ...rest }) {
    const {hasRole} = useAuth();
    
    if(!roles) return(
        <Route {...rest}>
        {KeyCloak.isLoggedIn() ?  children : KeyCloak.doLogin }
        </Route>
    );
    
    return (
    <Route {...rest}>
        {KeyCloak.isLoggedIn() ? KeyCloak.hasRole(roles) || hasRole(roles) ? children : <Redirect to="/" />  : KeyCloak.doLogin }
    </Route>
    );
}